module.exports = __webpack_public_path__ + "static/media/dashboard_page.558a8850.PNG";